'use client';

import { captureExceptionLazy } from '@/lib/sentry-client';
import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureExceptionLazy(error);
  }, [error]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
      <h1
        className="mb-2 text-6xl font-bold"
        style={{ color: 'var(--scw-navy, #1B5078)' }}
      >
        Something went wrong
      </h1>
      <p
        className="mb-8 max-w-md text-lg"
        style={{ color: 'var(--scw-gray-body, #666666)' }}
      >
        An unexpected error occurred. Please try again or contact support if the
        problem persists.
      </p>
      <button
        onClick={reset}
        className="rounded-md px-6 py-3 font-semibold text-white transition-colors"
        style={{
          backgroundColor: 'var(--scw-orange, #ED8326)',
        }}
        onMouseOver={(e) =>
          (e.currentTarget.style.backgroundColor =
            'var(--scw-orange-hover, #d97520)')
        }
        onMouseOut={(e) =>
          (e.currentTarget.style.backgroundColor =
            'var(--scw-orange, #ED8326)')
        }
      >
        Try again
      </button>
    </div>
  );
}
